<template>
  <v-layout>
    <v-dialog
      v-model="dialogVisible"
      max-width="1200px"
      persistent
      @click:outside="closeDialog"
    >
      <v-card style="background: rgb(221, 225, 230)">
        <v-form v-on:submit.prevent="finishOrder">
          <v-card-title>
            <span class="headline">{{ modal_title }}</span>
          </v-card-title>
          <v-card-text>
            <v-stepper v-model="currentStep" alt-labels style="background: rgb(221, 225, 230)">
              <div class="row justify-content-center mt-4">
                <div class="col-md-12">
                  <v-stepper-header style="background: #fff; box-shadow: none">
                    <v-stepper-step :complete="currentStep > 1" step="1">
                      Inicio
                    </v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step :complete="currentStep > 2" step="2">
                      Fórmula
                    </v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step :complete="currentStep > 3" step="3">
                      Adicionales
                    </v-stepper-step>
                  </v-stepper-header>
                </div>
              </div>

              <v-stepper-items>
                <v-stepper-content step="1" class="pl-0 pr-0 pt-1">
                  <StepInicio
                    :productionOrder="productionOrder"
                    :mainItem="mainItem"
                    @nextStep="nextStep"
                    :view_finish_order="view_finish_order"
                  />
                </v-stepper-content>

                <v-stepper-content step="2" class="pl-0 pr-0">
                  <StepFormula
                    :productionOrder="productionOrder"
                    :mainItem="mainItem"
                    @prevStep="prevStep"
                    @nextStep="nextStep"
                    :view_finish_order="view_finish_order"
                  />
                </v-stepper-content>

                <v-stepper-content step="3" class="pl-0 pr-0">
                  <StepConsumosAdicionales
                    :productionOrder="productionOrder"
                    :mainItem="mainItem"
                    @prevStep="prevStep"
                    :view_finish_order="view_finish_order"
                  />
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </v-card-text>

          <v-card-actions style="position: absolute; bottom: 0; width: 100%">
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="closeDialog">Cerrar</v-btn>
            <v-btn 
              color="success" 
              text 
              type="submit" 
              :disabled="currentStep <= 2" 
              :loading="saving"
              v-if="!view_finish_order"
            >
              Finalizar
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import StepInicio from "./ModalFinishedOrderSteps/StepInicio.vue";
import StepFormula from "./ModalFinishedOrderSteps/StepFormula.vue";
import StepConsumosAdicionales from "./ModalFinishedOrderSteps/StepConsumosAdicionales.vue";
import { productionOrderService } from "@/libs/ws/productionOrderService";

export default {
  components: {
    StepInicio,
    StepFormula,
    StepConsumosAdicionales,
  },
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    view_finish_order: {
      type: Boolean,
      default: false,
    },
    productionOrder: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      dialogVisible: false,
      currentStep: 1,
      saving: false,
      modal_title: "Finalizar Orden de Producción",
      mainItem: {
        id: null,
        end_date: new Date().toISOString().substr(0, 10),
        quantity_produced: null,
        external_reference: "",
        observacion_resultado: "",
        result_formula_items: [],
        additional_costs: [],
        additional_consumptions: [],
      },
    };
  },
  watch: {
    dialog(val) {
      this.dialogVisible = val;
      if (val && this.productionOrder) {
        this.initializeMainItem();
      }
    },
  },
  methods: {
    initializeMainItem() {
      if (this.productionOrder) {
        // Construir mainItem a partir del productionOrder que viene del padre
        this.currentStep = 1;
        this.mainItem = {
          id: this.productionOrder.id,
          end_date: new Date().toISOString().substr(0, 10),
          quantity_produced: this.productionOrder.quantity_produced != null ? this.productionOrder.quantity_produced : this.productionOrder.quantity_product_final,
          external_reference: this.productionOrder.external_reference || "",
          observacion_resultado: this.productionOrder.observacion_resultado || "",
          result_formula_items: this.productionOrder.result_formula_items || [],
          additional_costs: this.productionOrder.additional_costs || [],
          additional_consumptions: this.productionOrder.additional_consumptions || [],
        };
      }
    },
    nextStep() {
      if (this.currentStep < 3) {
        this.currentStep++;
      }
    },
    prevStep() {
      if (this.currentStep > 1) {
        this.currentStep--;
      }
    },
    finishOrder() {
      this.saving = true;

      // Armar el body con las propiedades _arr para el backend
      const bodyData = {
        id: this.mainItem.id,
        end_date: this.mainItem.end_date,
        quantity_produced: this.mainItem.quantity_produced,
        observacion_resultado: this.mainItem.observacion_resultado,
        result_formula_items_arr: this.mainItem.result_formula_items || [],
        additional_costs_arr: this.mainItem.additional_costs || [],
        additional_consumptions_arr: this.mainItem.additional_consumptions || [],
      };

      productionOrderService
        .finishOrder(bodyData)
        .then((response) => {
            if(response.status) { 

                this.saving = false;
                this.$toast.success("Orden finalizada correctamente", "OK");
                this.$emit("updated");
                this.closeDialog();
            } else { 
                this.saving = false;
                this.$toast.error(
                  response.message || "Error al finalizar la orden",
                  "Error"
                );
            }
        })
        .catch((error) => {
          this.saving = false;
          console.error("Error al finalizar orden:", error);
          this.$toast.error(
            error.response?.data?.message || "Error al finalizar la orden",
            "Error"
          );
        });
    },
    closeDialog() {
      this.dialogVisible = false;
      this.currentStep = 1;
      this.$emit("updateDialog", false);
    },
  },
};
</script>

<style scoped></style>
